export enum FoldersCreationTypes {
  Default = 0,
  OrderNumberAndMissionNumberOnly = 1,
  MissionFolderInsideOrderFolder = 2,
  DefaultButWithArrangedOrdersFolder = 3,
}
